module.exports = __webpack_public_path__ + "static/img/g7_new.70342e87.png";